// removed by extract-text-webpack-plugin
module.exports = {"list_inscriptions":"_2mLnwrW_nsWdyaSRWZE7Uh"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/MyInscriptions/style.css
// module id = 307
// module chunks = 37